import { Checkbox } from "@mantine/core";
import { AnyObject, GenericInput } from "../../models/generic";
import { InputWrapper } from "./styles";
import { FC } from "react";

interface Option {
  value: string;
  label: string;
}

export interface CheckboxGroupInputProps {
  afterChange?: (value: string[]) => void;
  input: GenericInput<string[]>;
  withAsterisk?: boolean;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
  meta: AnyObject;
  options?: Option[];
}

export const CheckboxGroupInput: FC<CheckboxGroupInputProps> = ({
  input,
  meta = {},
  label,
  placeholder,
  afterChange,
  disabled = false,
  withAsterisk = false,
  options,
  ...other
}) => {
  const handleChange = (value: string[]) => {
    input.onChange(value);
    if (afterChange && typeof afterChange === "function") {
      afterChange(value);
    }
  };

  const hasError = meta?.invalid && meta?.submitFailed;

  return (
    <InputWrapper hasError={hasError}>
      <Checkbox.Group
        label={label}
        value={input.value}
        onChange={handleChange}
        withAsterisk={withAsterisk}
        {...other}
      >
        {options?.length &&
          options.map((option: Option, index: number) => (
            <Checkbox
              key={index}
              value={option.value}
              label={option.label}
              style={{ marginBottom: "0.938rem" }}
            />
          ))}
      </Checkbox.Group>
    </InputWrapper>
  );
};

export default CheckboxGroupInput;
